// TextCell — shared controlled text/number input primitive for inline grid edits.
// Domain-neutral (Component_Contract Tier 1). Theme tokens only — no raw hex/fontSize/monospace.
// Uniform sizing/padding so inputs align under columns across every grid (CO3).
//
// Props:
//   value        — current value (controlled)
//   onChange     — (nextValue: string) => void   (receives the raw input string)
//   type?        — 'text' (default) | 'number' | any HTML input type
//   align?       — 'left' (default) | 'right' | 'center' — text alignment
//   placeholder? — placeholder text
//   onKeyDown?   — optional key handler (e.g. Enter=commit, Escape=cancel) forwarded to input
//   title?       — tooltip
//
// The input stops click propagation so clicking it never toggles row-select / edit mode.

import { CELL_INPUT_STYLE } from './cellStyles.js';

export default function TextCell({ value, onChange, type = 'text', align, placeholder, onKeyDown, title }) {
  return (
    <input
      type={type}
      value={value == null ? '' : String(value)}
      placeholder={placeholder}
      title={title}
      onChange={e => onChange(e.target.value)}
      onClick={e => e.stopPropagation()}
      onKeyDown={onKeyDown}
      style={{ ...CELL_INPUT_STYLE, textAlign: align || 'left' }}
    />
  );
}
